import * as callbackActions from '../actions/callback';
import * as fetchingState from '../constants/fetchingState';
import { getErrorMessage } from '../constants/errorCode';

const initialState = {
    fetching: fetchingState.INITIAL,
    callbacks: [],
    updateFetching: fetchingState.INITIAL,
    updateResult: undefined,
    historyFetching: fetchingState.INITIAL,
    history: [],
    error: undefined
};

export default function (callbacks, action) {
    if (action.data && action.data.refresh) {
        sessionStorage.removeItem('adm-token');
        return initialState;
    }

    switch (action.type) {
        case callbackActions.CLEAR_CALLBACK:
            return { ...callbacks, enquiries: [], fetching: fetchingState.INITIAL, error: undefined };
        case callbackActions.FETCH_CALLBACKS:
            return { ...callbacks, fetching: fetchingState.FETCHING, error: undefined };

        case callbackActions.SUCCESS_FETCH_CALLBACKS:
            sessionStorage.setItem('cachedCallbacksCount', action.data && action.data.length ? action.data.length : null);
            return { ...callbacks, enquiries: action.data, fetching: fetchingState.FETCHED, error: undefined };

        case callbackActions.FAILURE_FETCH_CALLBACKS:
            return { ...callbacks, fetching: fetchingState.FAILED, error: getErrorMessage(action.data.error) };

        case callbackActions.UPDATE_CALLBACK:
            return { ...callbacks, updateFetching: fetchingState.FETCHING, updateError: undefined }

        case callbackActions.SUCCESS_UPDATE_CALLBACK:
            if (action.data.error === undefined) {
                return { ...callbacks, updateFetching: fetchingState.FETCHED, updateError: undefined };
            }
        case callbackActions.FAILURE_UPDATE_CALLBACK:
            return { ...callbacks, updateFetching: fetchingState.FAILED, updateResult: action.data, updateError: getErrorMessage(action.data.error) };

        case callbackActions.CLEAR_UPDATE_CALLBACK:
            return { ...callbacks, updateFetching: fetchingState.INITIAL };

        case callbackActions.FETCH_CALLBACK_HISTORY:
            return { ...callbacks, historyFetching: fetchingState.FETCHING, error: undefined };

        case callbackActions.SUCCESS_FETCH_CALLBACK_HISTORY: {
            if (!action.data.error) {
                return { ...callbacks, historyFetching: fetchingState.FETCHED, history: action.data, error: undefined };
            }
        }

        case callbackActions.FAILURE_FETCH_CALLBACK_HISTORY: {
            return { ...callbacks, historyFetching: fetchingState.FETCHED, error: getErrorMessage(action.data.error) };
        }

        case 'GET_CALLBACK_ENQUIRIES_SUCCESS': {
            if (!action.data.error) {
                return { ...callbacks, enquiries: action.data || [], error: undefined }
            }
            return callbacks;
        }

        default:
            return callbacks;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/callbackReducer.js